import React from 'react'
import SEO from "../../components/atoms/seo"

import Layout from '../../components/organisms/layout'
import Heading from '../../components/molecules/heading'
import Questionnaire from '../../components/organisms/questionnaire'
import KeyFeatures from '../../components/molecules/key-features'

import steps from "../../data/pages/questionnaire/steps.json"
import verifyInformation from "../../data/pages/questionnaire/verify.json"
import content from "../../data/pages/questionnaire/content.json"

const QuestionnairePage = () => (
  <Layout>
    <SEO title={content.seo.title} />
    <Heading 
        title={content.heading.title}
        subTitle={content.heading.subTitle}
        weight='light'
    />
    <Questionnaire 
      steps={steps}
      verifyInformation={verifyInformation}
      disclaimer={content.disclaimer}
      onSubmitMessage={content.onSubmit.message}
      thankYouURL={content.onSubmit.thankYouURL}
      thankYouChatBot
    />
    <KeyFeatures
      features={[
        {
            title: '$12+ Billion in&nbsp;Debt&nbsp;Resolved',
            image: 'resolved.jpg',
            imageAlt: ''
        },
        {
            title: '2+ Million Customers&nbsp;Served',
            image: 'customers.jpg',
            imageAlt: ''
        },
        {
            title: 'Certified Debt&nbsp;Consultants',
            image: 'consultants.jpg',
            imageAlt: ''
        }
    ]}
    />
  </Layout>
)

export default QuestionnairePage
